import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MathGamesSharedModule } from '@games/games-shared/math-games-shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule,
  DefaultImageModule,
  FitTextModule,
  FormFieldModule,
  TextsFilterComponent,
} from '@shared/components/games';
import { NumberSystemsControllerComponent } from './number-systems-controller/number-systems-controller.component';
import { NumberSystemsCorrectAnswerPreviewComponent } from './number-systems-preview/number-systems-answer-preview/number-systems-answer-preview.component';
import { NumberSystemsExamplePreviewComponent } from './number-systems-preview/number-systems-example-preview/number-systems-example-preview.component';
import { NumberSystemsParametersPreviewComponent } from './number-systems-preview/number-systems-parameters-preview/number-systems-parameters-preview.component';
import { NumberSystemsUserAnswerPreviewComponent } from './number-systems-preview/number-systems-user-answer-preview/number-systems-user-answer-preview.component';
import { NumberSystemsSettingsComponent } from './number-systems-settings/number-systems-settings.component';
import { CalculatorLayoutComponent } from '@shared/components/games/input-layouts/calculator-layout/calculator-layout.component';

@NgModule({
  declarations: [
    NumberSystemsControllerComponent,
    NumberSystemsSettingsComponent,
    NumberSystemsCorrectAnswerPreviewComponent,
    NumberSystemsExamplePreviewComponent,
    NumberSystemsParametersPreviewComponent,
    NumberSystemsUserAnswerPreviewComponent,
  ],
  exports: [
    NumberSystemsControllerComponent,
    NumberSystemsSettingsComponent,
    NumberSystemsCorrectAnswerPreviewComponent,
    NumberSystemsExamplePreviewComponent,
    NumberSystemsParametersPreviewComponent,
    NumberSystemsUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    FitTextModule,
    NgSelectModule,
    DefaultImageModule,
    FormFieldModule,
    MathGamesSharedModule,
    CalculatorLayoutComponent,
    TextsFilterComponent,
  ],
})
export class NumberSystemsModule {}
